module.exports = __webpack_public_path__ + "img/swiper-5.a8c1a980.png";